import { FC, Fragment } from 'react'
import { AnchorProps } from '@chegg-wt/core/types/core'
import { CardContainer, CardHeading, RightArrow, SeeGuideText, SeoLinks } from './styled'

interface ResourceCardProps {
  heading: string
  seoLinks: AnchorProps[]
  guideLink: string
}

export const ResourceCard: FC<ResourceCardProps> = ({ heading, seoLinks, guideLink }) => {
  return (
    <CardContainer data-test="resource-cards">
      <CardHeading>{heading}</CardHeading>

      {seoLinks?.length > 0 && (
        <SeoLinks>
          {seoLinks.map(({ children, href }, index) => (
            <Fragment key={href}>
              {index > 0 ? ' | ' : ''}
              <a href={href}>{children}</a>
            </Fragment>
          ))}
        </SeoLinks>
      )}

      <a href={guideLink}>
        <SeeGuideText>
          See guide <RightArrow pointing="right" />
        </SeeGuideText>
      </a>
    </CardContainer>
  )
}
